import { gaPurchase } from "@/lib/ga4";
import { getIamportPayload, requestPay, useIamport } from "@/lib/iamport";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { PACKAGE_ORDER_COMPLETE } from "@/settings/constant";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useState } from "react";
import { PassCategory } from "src/api/membership";
import { postOrder } from "../../../api/booksOrder";
const orderTypeMap = {
    [PassCategory.Solvookplus]: 1,
    [PassCategory.Ticket]: 4,
    [PassCategory.Expert]: 6,
    [PassCategory.Package]: 8,
    [PassCategory.FreePass]: 9
};
const mixpanelMemoKey = "mixpanel-books-order";
export const useProductOrder = (param)=>{
    let { orderType , productId , postbackURL , completePage =false  } = param;
    const router = useRouter();
    const defaultPostbackURL = postbackURL || router.asPath //FIXME 확인필요
    ;
    const postOrderMutation = useMutation(postOrder);
    const { impRef  } = useIamport();
    const [payMethod, setPayMethod] = useState("card");
    const [isPayError, setIsPayError] = useState(false);
    const [isPaySuccess, setIsPaySuccess] = useState(false);
    const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState(false);
    const handlePayMethod = (method)=>{
        setPayMethod(method);
    };
    const handleOrder = async (e)=>{
        e.preventDefault();
        try {
            const order = await postOrderMutation.mutateAsync({
                orderType: orderTypeMap[orderType],
                productId: productId
            });
            const result = await requestPay(getIamportPayload({
                merchant_uid: order.merchantUid,
                name: order.title,
                amount: order.total,
                buyer_email: order.email,
                buyer_name: order.name,
                buyer_tel: order.phone,
                m_redirect_url: document.location.origin.concat(PACKAGE_ORDER_COMPLETE.concat("/".concat(order.id))),
                buyer_addr: "".concat(order.address, " ").concat(order.addressDetail),
                buyer_postcode: order.zipcode
            }, payMethod), impRef.current);
            if (result.success) {
                handleSuccess(order.id);
            } else {
                throw new Error(result.error_msg);
            }
        } catch (error) {
            setIsPayError(true) //FIXME 제거해도 되는지.
            ;
        }
    };
    const handleSuccess = (orderId)=>{
        setIsPaySuccess(true);
        setIsOpenSuccessDialog(true);
        const memo = sessionStorage.getItem(mixpanelMemoKey);
        if (memo && window.mixpanel) {
            const props = JSON.parse(memo);
            mixpanelEvent("Purchase Completed", props);
            gaPurchase({
                items: [
                    {
                        item_id: props["Product IDs"][0],
                        item_name: props["Product Names"][0],
                        price: props["Order Total"],
                        quantity: 1,
                        index: 0
                    }
                ],
                currency: "KRW",
                value: props["Order Total"],
                transaction_id: orderId,
                paymethod: payMethod
            });
        }
        //Fixme Package 하드코딩
        completePage && router.replace("/".concat(orderType, "/complete/").concat(orderId));
        sessionStorage.removeItem(mixpanelMemoKey);
    };
    return {
        handleOrder,
        payMethod,
        handlePayMethod,
        isPayError,
        isPaySuccess,
        isOpenSuccessDialog,
        setIsOpenSuccessDialog
    };
};
